// @optimyl/ui — what a form field is currently saying to the user, independent of how it looks.
//
// The precedence is shared; the palette is not. A field rendering "prefilled green" while it also holds a
// validation error is one the user submits without fixing.

export type FieldState = "default" | "prefilled" | "mismatch" | "error" | "readonly";

/**
 * Resolve the visible state of a field. Order matters — error wins over mismatch wins over readonly wins
 * over prefilled — so the user always sees the most actionable signal first.
 */
export function resolveFieldState(opts: {
  error?: string | null;
  isMismatch?: boolean;
  isPrefilled?: boolean;
  readOnly?: boolean;
}): FieldState {
  if (opts.error) return "error";
  if (opts.isMismatch) return "mismatch";
  if (opts.readOnly) return "readonly";
  if (opts.isPrefilled) return "prefilled";
  return "default";
}
